module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f60b.be42b472.svg";